import React from 'react';
import { gluteImages } from '../../data/gluteCopy';
export function GlutePreview() {
  return <section aria-labelledby="glute-preview" className="w-full bg-coal" data-id="element-150" data-mp="2r9kphux8w9zf">
      <div className="mx-auto w-full max-w-6xl px-5 py-16 sm:px-8 sm:py-24 lg:py-32" data-id="element-151" data-mp="2w975gc4gk4bx">
        <div className="grid items-center gap-10 lg:grid-cols-2 lg:gap-20" data-id="element-152" data-mp="2w748f84w1axp">
          <img src={gluteImages.ipad} alt="La guía Glute Lab abierta en un iPad sobre una superficie de concreto oscuro" className="w-full rounded-2xl" width={1200} height={900} data-id="element-153" data-mp="317rvxjtwr9n6" />

          <div data-id="element-154" data-mp="2diz33w8l1hws">
            <p className="text-[0.68rem] font-semibold uppercase tracking-[0.22em] text-ember" data-id="element-155" data-mp="2difksef0sri8">
              El producto
            </p>
            <h2 id="glute-preview" className="mt-5 text-[1.75rem] font-extrabold uppercase leading-[1.05] tracking-tight text-white sm:text-4xl" data-id="element-156" data-mp="2iaqntq524tf0">
              Un manual, no un PDF más
            </h2>
            <p className="mt-6 text-[1.02rem] leading-relaxed text-white/60 sm:text-lg" data-id="element-157" data-mp="2exb67ubqybkv">
              Léelo en tu teléfono, tu tablet o impreso. Cada página está diseñada para que sepas
              exactamente qué hacer hoy: sin videos de tres horas, sin rutinas genéricas, sin
              adivinar.
            </p>
            <ul className="mt-8 space-y-3 border-t border-coal-line pt-6 text-[0.95rem] text-white/55 sm:text-base" data-id="element-158" data-mp="214bsnxviyrfy">
              <li data-id="element-159" data-mp="1w7v452keyb2c">Formato PDF optimizado para leer en movimiento.</li>
              <li data-id="element-160" data-mp="1r6xn4tb53n2f">Calendario imprimible de 21 días.</li>
              <li data-id="element-161" data-mp="1r9a0et5yd995">Acceso de por vida, incluidas las actualizaciones.</li>
            </ul>
          </div>
        </div>
      </div>
    </section>;
}